import Form, { 
    ColCountByScreen, 
    GroupItem,
    Item,
    RequiredRule, 
    StringLengthRule 
} from 'devextreme-react/form';
import { 
    Button, 
    DateBox, 
    NumberBox, 
    SelectBox, 
    TextBox, 
    ValidationGroup, 
    Validator 
} from "devextreme-react";
import usePageTitle from '../hooks/usePageTitle';
import { fieldTypeNames } from '../BuildingsPage/Shared/shared';
import { ToolbarForm } from '../components/toolbar-form/toolbar-form';
import { LoadingPanel } from '../components/LoadingPanel';
import './GeneralFormConfig.scss';


const GeneralFormConfig = (
    {
        className,
        // customizeItem,
        groupedFields = [],
        loadingIndicatorMessage,
        loadingIndicatorState,
        loadingIndicatorLocationId,
        UserId,
        stringLengthRuleEnabled,
        stringLengthRuleMessage,
        stringMaxLength,
        stringMinLength,
        title,
        toolbarConfiguration = {},
        validationGroupRef
    }
) => {
    usePageTitle(title);

    return (
        <div
            className="block__main-listView block__main-listView-parent"
            id={loadingIndicatorLocationId}
        >
            {
                loadingIndicatorState && 
                <LoadingPanel 
                    location={{ of: loadingIndicatorLocationId }}
                    message={ loadingIndicatorMessage }
                />
            }
            <>
                <div className="block__heading-one">
                    <h1> { title } </h1>
                </div>

                <ValidationGroup ref={validationGroupRef}>
                    <ToolbarForm 
                        toggleEditing={toolbarConfiguration?.toggleEditing}
                        onSaveClick={toolbarConfiguration?.onSaveClick}
                        onBackClick={toolbarConfiguration?.onBackClick}
                        editing={toolbarConfiguration?.editing}
                        onCancelClick={toolbarConfiguration?.onCancelClick}
                        children={toolbarConfiguration?.children}
                    />
                    <Form
                        className={className}
                        labelMode='floating'
                        // customizeItem={customizeItem}
                        ref={validationGroupRef}
                        validationGroup='general-Form'
                    >
                        {
                            Array.isArray(groupedFields) && groupedFields.map((group, index) => (
                                <>
                                    <GroupItem
                                        colCount={4}
                                        caption={`${group.groupCaption} ${UserId ?? ''}`}
                                        key={index}
                                    >
                                        <ColCountByScreen xs={6} />
                                        {
                                            Array.isArray(group.fields) &&
                                            group.fields.map((key, index) => {
                                                const {
                                                    displayExpr,
                                                    format,
                                                    fieldType,
                                                    icon,
                                                    items,
                                                    label,
                                                    minimumValue,
                                                    onValueChanged,
                                                    options,
                                                    placeholderText,
                                                    readOnly,
                                                    requiredRuleEnabled, 
                                                    requiredRuleMessage,
                                                    requiredRulePattern,
                                                    value,
                                                    valueExpr
                                                } = key;

                                                switch (fieldType) {
                                                    case fieldTypeNames.dateBox:
                                                        return (
                                                            <Item key={index}>
                                                                <DateBox
                                                                    elementAttr={{ class: 'form-editor' }}
                                                                    inputAttr={
                                                                        { 
                                                                            class: readOnly ? 'form-editor-input' : 'dx-texteditor dx-editor-filled form-editor-input',
                                                                            'aria-label': label 
                                                                        }
                                                                    }
                                                                    label={label}
                                                                    onValueChanged={onValueChanged}
                                                                    readOnly={readOnly}
                                                                    value={value}
                                                                >
                                                                    <Validator validationGroup="general-Form">
                                                                        {
                                                                            requiredRuleEnabled &&
                                                                            <RequiredRule
                                                                                message={requiredRuleMessage}
                                                                            />
                                                                        }
                                                                    </Validator>
                                                                </DateBox>
                                                            </Item>
                                                        );
                                                    case fieldTypeNames.numberBox:
                                                        return (
                                                            <Item key={index}>
                                                                <NumberBox
                                                                    elementAttr={{ class: 'form-editor' }}
                                                                    format={format}
                                                                    inputAttr={
                                                                        { 
                                                                            class: readOnly ? 'form-editor-input' : 'dx-texteditor dx-editor-filled form-editor-input',
                                                                            'aria-label': label 
                                                                        }
                                                                    }
                                                                    label={label}
                                                                    min={minimumValue ?? 0}
                                                                    onValueChanged={onValueChanged}
                                                                    readOnly={readOnly}
                                                                    value={value}
                                                                >
                                                                    <Validator validationGroup="general-Form">
                                                                        {
                                                                            requiredRuleEnabled &&
                                                                            <RequiredRule
                                                                                message={requiredRuleMessage}
                                                                            />
                                                                        }
                                                                    </Validator>
                                                                </NumberBox>
                                                            </Item>
                                                        );
                                                    case fieldTypeNames.selectBox:
                                                        return (
                                                            <Item key={index}>
                                                                <SelectBox
                                                                    dataSource={options}
                                                                    displayExpr={displayExpr}
                                                                    elementAttr={{ class: 'form-editor'}}
                                                                    inputAttr={{
                                                                        class: readOnly ? 'form-editor-input' : 'dx-texteditor dx-editor-filled form-editor-input',
                                                                        'aria-label': label
                                                                    }}
                                                                    label={label}
                                                                    // items={items}
                                                                    onValueChanged={onValueChanged}
                                                                    placeholder={placeholderText}
                                                                    readOnly={readOnly}
                                                                    value={value}
                                                                    valueExpr={valueExpr}
                                                                >
                                                                    <Validator validationGroup='mainFomr'>
                                                                        {
                                                                            requiredRuleEnabled &&
                                                                            <RequiredRule 
                                                                                message={requiredRuleMessage}
                                                                                pattern={requiredRulePattern}
                                                                            />
                                                                        }
                                                                    </Validator>
                                                                </SelectBox>
                                                            </Item>
                                                        );
                                                    case fieldTypeNames.textBox:
                                                        return (
                                                            <Item key={index}>
                                                                <TextBox
                                                                    elementAttr={{ class: 'form-editor' }}
                                                                    inputAttr={
                                                                        { 
                                                                            class: readOnly ? 'form-editor-input' : 'dx-texteditor dx-editor-filled form-editor-input',
                                                                            'aria-label': label 
                                                                        }
                                                                    }
                                                                    label={label}
                                                                    onValueChanged={onValueChanged}
                                                                    readOnly={readOnly}
                                                                    value={value}
                                                                >
                                                                    {
                                                                        icon &&
                                                                        <Button
                                                                            location='after'
                                                                            name='icon'
                                                                            options={{
                                                                                icon: icon,
                                                                                elementAttr: { class: 'form-editor-icon' },
                                                                                stylingMode: 'text'
                                                                            }} 
                                                                        />
                                                                    }
                                                                    <Validator validationGroup="general-Form">
                                                                        {
                                                                            requiredRuleEnabled &&
                                                                            <RequiredRule
                                                                                message={requiredRuleMessage}
                                                                            />
                                                                        }
                                                                        {
                                                                            stringLengthRuleEnabled &&
                                                                            <StringLengthRule 
                                                                                max={stringMaxLength}
                                                                                message={stringLengthRuleMessage}
                                                                                min={stringMinLength}
                                                                            />
                                                                        }
                                                                    </Validator>
                                                                </TextBox>
                                                            </Item>
                                                        );
                                                    }
                                            })
                                        }
                                    </GroupItem>              
                                </>                                       
                            ))
                        }
                    </Form>
                </ValidationGroup>
            </>
        </div>
    );
};

export default GeneralFormConfig;